import request from '@/utils/request'


export function getMySalesData(data){
  return request({
    url: '/user/getmysalesdata',
    method: 'post',
    data
  })
}

export function getSalesData(params) {
  return request({
    url: '/user/getsalesdata',
    method: 'get',
    params: params
  })
}

// 更新用户信息
export function updateUserInfo(data) {
  return request({
    url: '/user/update',
    method: 'post',
    data
  })
}

export function readMessages(params) {
  return request({
    url: '/user/readmessages',
    method: 'get',
    params: params
  })
}

export function getMyMessages(params) {
  return request({
    url: '/user/getmymessages',
    method: 'get',
    params: params
  })
}

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/auth/info',
    method: 'post'
    // params: { token }
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function getCaptcha() {
  return request({
    url: '/auth/Captcha',
    method: 'get'
  })
}
